import { ReactElement } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import { IAuditLog } from '~/services/api/auditLogs/types';

import styles from './Item.module.scss';

interface IProps {
  item: IAuditLog;
  isWhite: boolean;
}

const Item = ({ item, isWhite }: IProps): ReactElement => (
  <TableRow className={classnames({ [styles.whiteRow]: isWhite })}>
    <TableCell className={classnames({ [styles.whiteCell]: isWhite })}>
      {format(new Date(item.createdAt), 'yyyy/MM/dd HH:mm:ss')}
    </TableCell>
    <TableCell className={classnames(styles.cell, { [styles.whiteCell]: isWhite })}>
      {item.userFullName}
    </TableCell>
    <TableCell className={classnames(styles.cell, { [styles.whiteCell]: isWhite })}>
      {item.link ? (
        <Link to={item.link} className={styles.link}>
          {item.message}
        </Link>
      ) : (
        item.message
      )}
    </TableCell>
    <TableCell className={classnames({ [styles.whiteCell]: isWhite })}>{item.areaName}</TableCell>
    <TableCell className={classnames(styles.cell, { [styles.whiteCell]: isWhite })}>
      {item.programName}
    </TableCell>
    <TableCell className={classnames({ [styles.whiteCell]: isWhite })}>{item.eventName}</TableCell>
  </TableRow>
);

export default Item;
